import { useTableServer } from "@/hooks/useTableServer.tsx";
import FilterPayment from "@/app/app-shared/package/payment-table/filter-payment.tsx";
import ControlledTable from "@/components/controlled-table";
import { useCallback, useMemo } from "react";
import { getColumns } from "@/app/app-shared/package/payment-table/columns.tsx";
import PaymentRepository from "@/utilities/repositories/Payment.ts";
import { EActionMethod } from "@/utilities/types/Payment.ts";
import toast from "react-hot-toast";

const PaymentTable = () => {
  const {
    isLoading,
    tableData,
    currentPage,
    totalItems,
    handlePaginate,
    pageSize,
    handleChangePageSize,
    searchTerm,
    handleSearch,
    sortConfig,
    handleReset,
    handleSort,
    refresh,
  } = useTableServer({
    server: {
      request: PaymentRepository.getAllPayment,
    },
    searchBy: (searchTerm) => {
      const s = searchTerm || undefined;
      return {
        search: s,
      };
    },
  });

  const onHeaderCellClick = (value: string) => ({
    onClick: () => {
      handleSort(value);
    },
  });

  const changeStatusPayment = useCallback(
    async (id: string, type: string, reason: string = "") => {
      const toastId = toast.loading("Updating status...");
      try {
        if (type === EActionMethod.APPROVED) {
          await PaymentRepository.approvePayment(id);
        } else if (type === EActionMethod.REJECTED) {
          await PaymentRepository.rejectPayment({ xeroInvoiceID: id, reason });
        }
        toast.success("Status update successful!", { id: toastId });
        handleReset();
      } catch (error) {
        toast.error("Status update failed!", { id: toastId });
      }
    },
    [handleReset]
  );

  const columns = useMemo(
    () =>
      getColumns({
        data: tableData,
        sortConfig,
        refresh,
        onHeaderCellClick,
        changeStatusPayment,
      }),
    [
      onHeaderCellClick,
      sortConfig.key,
      sortConfig.direction,
      tableData,
      changeStatusPayment,
    ]
  );

  return (
    <div>
      <FilterPayment onSearch={handleSearch} searchTerm={searchTerm} />
      <ControlledTable
        variant="modern"
        data={tableData}
        isLoading={isLoading}
        showLoadingText={true}
        // @ts-expect-error - The ControlledTable component expects a different column type
        columns={columns}
        paginatorOptions={{
          pageSize,
          setPageSize: handleChangePageSize,
          total: totalItems,
          current: currentPage,
          onChange: (page: number) => handlePaginate(page),
        }}
        className="rounded-md border border-muted text-sm shadow-sm [&_.rc-table-placeholder_.rc-table-expanded-row-fixed>div]:h-60 [&_.rc-table-placeholder_.rc-table-expanded-row-fixed>div]:justify-center [&_.rc-table-row:last-child_td.rc-table-cell]:border-b-0 [&_thead.rc-table-thead]:border-t-0"
      />
    </div>
  );
};

export default PaymentTable;
